const reportingFilterDateRanges = [
    { _id: '1', range_name: 'This Year', correspondingComparison: '1' },
    { _id: '2', range_name: 'This Quarter', correspondingComparison: '2' },
    { _id: '3', range_name: 'First Half', correspondingComparison: '3' },
    { _id: '4', range_name: 'This Month', correspondingComparison: '4' },
    { _id: '5', range_name: 'Year (Select a year)', correspondingComparison: '5' },
    { _id: '6', range_name: 'Month (Select a month)', correspondingComparison: '6' },
];

export default reportingFilterDateRanges;